import React, { useState } from 'react'
import { Card, CardBody, Table, Button, Spinner } from 'reactstrap'
import { useSelector } from 'react-redux'

const BackupReconciliationCard = ({ reconciliation, onAddUsersClick }) => {
  const addUsersLoading = useSelector((state) => state.backup365Reports.addUsersLoading)

  // Track which product is in "confirm mode"
  const [confirmProductId, setConfirmProductId] = useState(null)

  if (!reconciliation) {
    return (
      <Card className="shadow-sm border-0 mb-4">
        <CardBody>
          <h5 className="fw-bold mb-2">Backup Reconciliation</h5>
          <p className="text-muted mb-0">No reconciliation found for this company or report date.</p>
        </CardBody>
      </Card>
    )
  }

  const formattedMonth = new Date(reconciliation.reconciliationMonth).toLocaleDateString('en-AU', {
    month: 'long',
    year: 'numeric',
  })

  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody>
        <h5 className="fw-bold mb-3">Backup Reconciliation</h5>

        <div className="mb-3">
          <strong>Reconciliation Month:</strong> {formattedMonth} <br />
          <strong>Status:</strong> {reconciliation.status ?? 'Unknown'}
        </div>

        <Table bordered hover responsive className="mt-3">
          <thead className="table-light">
            <tr>
              <th style={{ width: '40%' }}>Product</th>
              <th style={{ width: '20%' }}>User Count</th>
              <th style={{ width: '20%' }} className="text-center">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {reconciliation.reconciliationProducts?.length > 0 ? (
              reconciliation.reconciliationProducts.map((product) => {
                const isConfirming = confirmProductId === product.id

                return (
                  <tr key={product.id}>
                    <td>{product.name}</td>
                    <td>{product.users?.length ?? 0}</td>

                    <td className="text-center">
                      {/* If user clicked Add Users for this row, show Confirm/Cancel */}
                      {isConfirming ? (
                        <div className="d-flex justify-content-center gap-2">
                          <Button
                            size="sm"
                            color="success"
                            disabled={addUsersLoading}
                            onClick={() => onAddUsersClick(product.id)}
                          >
                            {addUsersLoading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Confirming...
                              </>
                            ) : (
                              'Confirm'
                            )}
                          </Button>

                          <Button
                            size="sm"
                            color="secondary"
                            disabled={addUsersLoading}
                            onClick={() => setConfirmProductId(null)}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        // Default Add Users button
                        <Button
                          size="sm"
                          color="primary"
                          disabled={addUsersLoading}
                          onClick={() => setConfirmProductId(product.id)}
                        >
                          Add Users
                        </Button>
                      )}
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="3" className="text-muted text-center">
                  No reconciliation products found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  )
}

export default BackupReconciliationCard
